import { motion } from "framer-motion";
import { RotateCcw, Volume2 } from "lucide-react";
import { fmtTime } from "@/lib/api";
import { TaskCard, ApprovalCard } from "@/components/TaskCards";

export const MessageItem = ({ m, task, approval, onRetry, onSpeak, onChange }) => {
  const isUser = m.role === "user";
  return (
    <motion.article initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`message-${m.role}`} data-message-id={m.id}
      className={`py-7 border-b border-[#151515] ${isUser ? "md:pl-24" : ""}`}>
      <header className="flex items-center gap-3 mb-3">
        <span className={`h-1.5 w-1.5 rounded-full ${isUser ? "bg-[#8A8A8A]" : "bg-[#D8BFD8]"}`} />
        <span className={`text-[0.65rem] tracking-[0.28em] uppercase ${isUser ? "text-[#8A8A8A]" : "text-[#D8BFD8]"}`}>{isUser ? "You" : "Feerd"}</span>
        {m.channel && m.channel !== "web" && <span className="text-[0.6rem] tracking-[0.2em] uppercase text-[#5f5f5f]">via {m.channel}</span>}
        <span className="text-[0.65rem] text-[#4a4a4a]">{fmtTime(m.created_at)}</span>
        {m.delivery_status && <span className="text-[0.6rem] tracking-[0.2em] uppercase text-[#5f5f5f]" data-testid="message-delivery-status">{m.delivery_status}</span>}
      </header>
      <div className={`whitespace-pre-wrap leading-relaxed ${isUser ? "text-[#C0C0C0] text-sm md:text-base" : "text-ivory text-[0.95rem] md:text-[1.05rem] font-light"}`} data-testid="message-content">
        {m.content}
        {m.pending && !m.content && <span className="inline-block text-[#8A8A8A] italic font-display text-lg">considering…</span>}
        {m.pending && m.content && <span className="inline-block w-2 h-4 ml-1 bg-[#D8BFD8]/70 animate-pulse align-middle" />}
      </div>
      {m.status === "error" && (
        <div className="mt-4 flex items-center gap-4" data-testid="message-error">
          <span className="text-sm text-[#e2a6a6]">{m.error || "This reply failed."}</span>
          {onRetry && (!m.kind || m.kind === "text") && <button onClick={onRetry} data-testid="message-retry-button" className="text-[0.65rem] tracking-[0.2em] uppercase text-[#C0C0C0] hover:text-ivory inline-flex items-center gap-1.5"><RotateCcw className="h-3 w-3" />Retry</button>}
        </div>
      )}
      {!isUser && !m.pending && m.status !== "error" && m.content && onSpeak && (
        <button onClick={() => onSpeak(m.content)} data-testid="message-speak-button" aria-label="Read aloud" className="mt-3 text-[#4a4a4a] hover:text-[#C0C0C0] transition-colors"><Volume2 className="h-3.5 w-3.5" strokeWidth={1.5} /></button>
      )}
      {task && m.kind === "task" && !m.content.startsWith("Research complete") && !m.content.startsWith("Research task failed") && <TaskCard task={task} onChange={onChange} />}
      {approval && m.kind === "approval" && <ApprovalCard approval={approval} onChange={onChange} />}
    </motion.article>
  );
};
